<template>
  <div class="kpt-jobs-root kpt-list-page">
    <vue-headful :title="title" />
    <header class="kpt-list-header">
      <h4>Active Jobs</h4>
      <div class="page-control">
        <!-- <font-awesome-icon :icon="['far', 'thumbtack']" @click="pinToDash('remoteList', { name: 'Remote List' })" title="Pin to Dashboard" class="has-cursor-pointer" /> -->
      </div>
    </header>
    <div class="kpt-list-table">
      <b-table
        :data="jobs"
        :narrowed="true"
        :hoverable="true"
        :loading="isLoading"
        sort-icon="chevron-up"
        sort-icon-size="is-small"
        ref="jobsTable"
        class="has-horizontal-scroll is-full-height">
        <b-table-column field="id" label="Id" v-slot="props" cell-class="is-200" :meta="{ field: 'Id' }">
          <router-link :to="{ name: 'jobDetail', params: { id: props.row.id } }">{{props.row.id}}</router-link>
        </b-table-column>
        <b-table-column field="createdOn" label="Created On (UTC)" v-slot="props" sortable cell-class="is-140" :meta="{ field: 'CreatedOn' }">
          {{ props.row.createdOn ? format(new Date(props.row.createdOn), 'yyyy-MM-dd HH:mm:ss') : "-" }}
        </b-table-column>
        <b-table-column field="status" label="Status" v-slot="props" sortable cell-class="is-160" :meta="{ field: 'Status' }">
          <span :title="props.row.status">{{ props.row.status || '-' }}</span>
        </b-table-column>
        <template slot="empty">
          <p>No active jobs were found.</p>
        </template>
      </b-table>
    </div>
  </div>
</template>
<script>
import { format } from 'date-fns';

export default {
  data() {
    return {
      isLoading: false,
      format
    }
  },
  async mounted() {
    this.isLoading = true;
    await this.$store.dispatch('fetchJobs');
    this.isLoading = false;
  },
  computed: {
    title() {
      return this.$route.name;
    },
    jobs() {
      return this.$store.state.jobs.jobs;
    }
  },
  methods: {
    parseUtcDate(dateString) {
      const now = new Date(dateString);
      const utc = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
      return utc;
    }
  }
}
</script>
<style lang="scss" scoped>
.kpt-jobs-root {
  position: relative;
  height: 100%;

  .kpt-list-table {
    width: 100%;
  }
}
</style>
